export const PRIVACY_SCOPE_FIELD_NEW = {
  HEADHUNTER_SELECTION_COMPANY: 'headhunterSelectionCompany',
  HEADHUNTERS_RECOMMEND_CANDIDATES: 'headhuntersRecommendCandidates',
};
